import { render, staticRenderFns } from "./newDesign.vue?vue&type=template&id=59d32c10&scoped=true"
import script from "./newDesign.vue?vue&type=script&lang=js"
export * from "./newDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d32c10",
  null
  
)

export default component.exports